// extracted by mini-css-extract-plugin
export default {"container":"UxJeCGMc","pencil":"ITgEPI2T"};